import React from "react";
import { Box, Tabs, Tab } from "@mui/material";
import { MonitoringFeed } from "./data/monitoring-service";

interface FeedTabsProps {
  feeds: MonitoringFeed[];
  selectedFeed: number;
  onFeedChange: (feedIndex: number) => void;
}

const FeedTabs: React.FC<FeedTabsProps> = ({
  feeds,
  selectedFeed,
  onFeedChange,
}) => {
  if (feeds.length <= 1) {
    return null;
  }

  return (
    <Box sx={{ mb: 3 }}>
      <Tabs
        value={selectedFeed}
        onChange={(_e, newValue) => onFeedChange(newValue)}
        sx={{ borderBottom: 1, borderColor: "divider" }}
      >
        {feeds.map((feed) => (
          <Tab
            key={feed.feedTitle || feed.lastBuildDate}
            label={feed.feedTitle || `Feed`}
            sx={{ textTransform: "none", fontWeight: 600 }}
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default FeedTabs;
